module.exports = __webpack_public_path__ + "img/stefan-tauber.4f0f1131.png";